import React from 'react';
import { Auth } from '@justgiving/auth';

export const AuthContext = React.createContext<Auth | null>(null);
